import { CompraDetalle } from "./compra_detalle";
import { Proveedor } from "./proveedor";
import { Bodega } from "./bodega";
import { Cliente } from "./cliente";
import { Pago } from "./pago";
import { PagoGrupo } from "./pago-grupo";
import { Retencion } from './retencion';
import { Guiaremision } from "./guiaremision";
import { Amortizacion } from "./amortizacion";
import { NotaCredito } from "./nota-credito";
import { AsientoContable } from "./asiento-contable";

export class Compra {
    public constructor(
        public id: String = "",
        public numero_documento: String = "",
        public tipo_comprobante_id: String = "1",
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public fecha_caducidad: String = "",
        public fecha_emision: any = "",
        public tipo: String = "CO",
        public numero_autorizacion: String = "",
        public tipo_actividad: String = "C",
        //
        public subtotal_iva12: number = 0,
        public subtotal_iva0: number = 0,
        public desct_valor: number = 0,
        public subtotal: number = 0,
        public desct_porcent:number = 0,
        public subt_desct_iva12:number = 0,
        public subt_desct_iva0:number = 0,
        //
        public iva: number = 0,
        public abonado: number = 0,
        public total: number = 0,

        public observacion: String = "",
        public cod_est: String = "",
        public json_string: any = {},
        //public tipo_documento_id: String = "",
        public caja_id: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public proveedor_id: String = "",
        public bodega_id: String = "1",
        public forma_pago_facturacion_id: String = "",
        public usuario_id: String = null,
        public selected: boolean = false,
        public detalle: Array<CompraDetalle> = [],
        public cliente: Cliente = new Cliente(),

        //

        public total_cv_cantidad: number = 0,
        public total_cv_valor: number = 0,
        public total_30ds: number = 0,
        public total_60ds: number = 0,
        public total_90ds: number = 0,
        public total_120ds: number = 0,
        public total_mas120ds: number = 0,
        public total_por_vencer: number = 0,
        public total_cuotas: number = 0,



        //
        public proveedor: Proveedor = new Proveedor(),
        public bodega: Bodega = new Bodega(),
        public pagos: Array<Pago> = [],

        //public pagos: Array<PagoGrupo> = [],
        public tipocomprobante: any = {},
        public retencion: Retencion = new Retencion(),
        public grupo: Array<PagoGrupo> = [],
        public guiaremision: Guiaremision = new Guiaremision(),
        public amortizacion: Amortizacion = new Amortizacion(),
        public notacredito: any = {},

        public asientosContables: Array<AsientoContable> = [],
    ) { }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/compra.ts